import { render, staticRenderFns } from "./RfxEventDashboard.vue?vue&type=template&id=39560e3a"
import script from "./RfxEventDashboard.vue?vue&type=script&lang=js"
export * from "./RfxEventDashboard.vue?vue&type=script&lang=js"
import style0 from "./RfxEventDashboard.vue?vue&type=style&index=0&id=39560e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports